import {
  PROJECTS_PAGINATED_FETCH_STARTED,
  PROJECTS_PAGINATED_FETCH_SUCCEEDED,
  PROJECTS_PAGINATED_FETCH_FAILED,
  PROJECTS_PAGINATED_CHANGE_PAGE,
  PROJECTS_PAGINATED_CHANGE_ITEMS_PER_PAGE,
  PROJECTS_PAGINATED_CHANGE_ORDER,
  PROJECTS_PAGINATED_CHANGE_ORDER_BY,
  PROJECTS_PAGINATED_CHANGE_ORDER_AND_ORDER_BY,
  PROJECTS_PAGINATED_SET_FILTER,
  PROJECTS_PAGINATED_TOGGLE_EXPIRIED,
  PROJECTS_PAGINATED_CLEAR,
  PROJECTS_PAGINATED_SET_PROJECT_DEVICE,
  PROJECTS_PAGINATED_REMOVE_PROJECT_DEVICE
} from '#action/types';
import { requestStatuses as statuses } from '#helper';
// , sortDevices, sortUsers
const defaultState = {
  status: statuses.idle,
  projects: [],
  error: null,
  page: 1,
  itemsPerPage: 50,
  order: 'asc',
  orderBy: 'parent',
  pages: 0,
  filter: null,
  filterBy: ['title'],
  hideExpiredProjects: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case PROJECTS_PAGINATED_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case PROJECTS_PAGINATED_FETCH_SUCCEEDED:
      const { projects, users, devices } = action.payload;
      return {
        ...state,
        status: statuses.succeeded,
        projects: projects ? projects.map(project => ({
          ...project,
          users: users?.find(u => u.id === project.id)?.count ?? null,
          devices: devices?.find(d => d.id === project.id)?.count ?? null
        })) : [],
        pages: Math.ceil(action.totalCount / state.itemsPerPage),
        totalCount: action.totalCount
      };
    case PROJECTS_PAGINATED_FETCH_FAILED:
      return { ...state, status: statuses.failed, projects: [], error: action.error };
    case PROJECTS_PAGINATED_CHANGE_PAGE:
      return { ...state, page: action.payload };
    case PROJECTS_PAGINATED_CHANGE_ITEMS_PER_PAGE:
      return { ...state, itemsPerPage: action.payload };
    case PROJECTS_PAGINATED_CHANGE_ORDER:
      return { ...state, order: action.payload };
    case PROJECTS_PAGINATED_CHANGE_ORDER_BY:
      return { ...state, orderBy: action.payload };
    case PROJECTS_PAGINATED_CHANGE_ORDER_AND_ORDER_BY:
      return { ...state, order: action.payload.order, orderBy: action.payload.orderBy };
    case PROJECTS_PAGINATED_SET_FILTER:
      return { ...state, filter: action.payload };
    case PROJECTS_PAGINATED_TOGGLE_EXPIRIED:
      return { ...state, hideExpiredProjects: action.payload };
    case PROJECTS_PAGINATED_SET_PROJECT_DEVICE:
      return {
        ...state,
        projects: state.projects.map(p => {
          if (p.id === action.payload.projectId) {
            return {
              ...p,
              devices: action.payload.devices
            };
          }
          return p;
        })
      };

    case PROJECTS_PAGINATED_REMOVE_PROJECT_DEVICE:
      return {
        ...state,
        projects: state.projects.map(p => {
          if (p.id === action.payload.projectId) {
            return {
              ...p,
              devices: action.payload.devices
            };
          }
          return p;
        })
      };
    case PROJECTS_PAGINATED_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
